
import { SupportedLanguage } from './types';

export const LOGO_URL = "https://i.imgur.com/AGdM3aQ.png";

export const BRAND_COLORS = {
  primary: '#00ffff', // Electric Cyan
  secondary: '#0066ff', // Deep Blue
  accent: '#ff6600', // Orange-Red
  bg: '#000000', // Pure Black
  surface: '#0a0a0a' // Dark Gray
};

export const LOGO_PROMPT = `Large, bold 3D logo design, minimal empty space, ultra-tight crop, black background. 
MAIN ELEMENT: Massive stylized letter "V" in 3D. Gradient: bright cyan (#00ffff) to deep blue (#0066ff). Orange-red (#ff6600) accent stripe on the right edge. 
BACKGROUND: Upward diagonal arrow (orange-yellow top, metallic gray bottom), glossy blue sphere, flowing blue curved shapes, camera lens circular element (gray rings, glowing blue-orange core), orange motion accents. 
Futuristic, high-tech, bold, cyberpunk aesthetic, high contrast.`;

export const TRANSLATIONS: Record<string, Record<string, string>> = {
  en: {
    // ... existing translations ...
    login_title: "Sign In",
    login_subtitle: "Join the ultimate fitness ecosystem",
    login_email: "Email Address",
    login_password: "Password",
    login_btn: "Continue with Email",
    login_google: "Continue with Google",
    login_facebook: "Continue with Facebook",
    signup_title: "Create Account",
    need_account: "Need an account? Sign Up",
    have_account: "Already have an account? Login",
    
    // Onboarding
    onboarding_welcome: "Welcome to VitaCore",
    step_terms: "Terms & Conditions",
    step_personal: "Personal Info",
    step_body: "Body Metrics",
    step_health: "Health & Diet",
    step_plan: "Choose Your Plan",
    accept_terms: "I accept the Terms and Conditions",
    label_name: "Name",
    label_email: "Email",
    label_age: "Age",
    label_sex: "Sex",
    label_height: "Height (cm)",
    label_weight: "Weight (kg)",
    btn_next: "Next",
    btn_start: "Start VitaCore",
    
    // Plans
    plan_free: "VitaCore FREE",
    plan_free_price: "$0/mo",
    plan_free_desc: "Access to Social Feed and Shop only",
    plan_pro: "VitaCore PRO",
    plan_pro_price: "$9.99/mo",
    plan_pro_desc: "Custom AI Workouts, Progress Tracking, History",
    plan_unlimited: "VitaCore UNLIMITED",
    plan_unlimited_price: "$14.99/mo",
    plan_unlimited_desc: "Everything in PRO + AI Diet Plans, Active Maps, Advanced Stats",
    
    // Navigation
    nav_feed: "Social Feed",
    nav_coach: "AI Coach",
    nav_map: "Active Maps",
    nav_shop: "Shop",
    nav_dashboard: "Dashboard",
    nav_dash: "Dashboard",
    nav_groups: "Groups",
    nav_settings: "Settings",
    nav_referral: 'Earn Rewards',
    
    // Social Feed
    social_for_you: "For You",
    social_following: "Following",
    social_new_post: "New Post",
    social_post_placeholder: "What's on your mind?",
    social_post_btn: "Post",
    social_search_people: "Search people",
    social_follow: "Follow",
    social_following_btn: "Following",
    social_likes: "likes",
    social_comments: "comments",
    social_reply_placeholder: "Reply...",
    social_reply_btn: "Reply",
    
    // Coach
    coach_title: "AI Coach",
    coach_intro: "I am your VitaCore AI Coach. Ask me about workouts, diet plans, or analyze your food.",
    coach_placeholder: "Describe your workout goal or meal...",
    coach_send: "Send",
    coach_thinking: "Thinking...",
    
    // Maps
    map_title: "Find Gyms & Routes",
    map_gyms: "Gyms",
    map_running: "Running Routes",
    map_cycling: "Cycling",
    map_trekking: "Trekking",
    map_view_on_maps: "View on Maps",
    map_select_category: "Select a category to find routes or gyms",
    
    // Shop
    shop_title: "VitaCore Shop",
    shop_all: "All",
    shop_clothing: "Clothing",
    shop_equipment: "Equipment",
    shop_supplements: "Supplements",
    shop_add_to_cart: "Add to Cart",
    
    // Dashboard
    dash_title: "Dashboard",
    dash_my_plans: "My AI Plans",
    dash_edit_profile: "Update Body Metrics",
    dash_creator_mode: "Creator Mode",
    dash_user_mode: "User Mode",
    dash_challenges: "Active Challenges",
    dash_create_challenge: "Create Challenge",
    dash_join_challenge: "Join",
    dash_joined: "Joined",
    dash_log_activity: "Log Activity",
    dash_progress: "Progress",
    dash_participants: "Participants",
    dash_challenge_completed: "Challenge Completed!",
    dash_claim_reward: "Claim Reward",
    
    // Groups
    groups_title: "Local Creator Hubs",
    groups_subtitle: "Join local running clubs or creator communities",
    groups_join: "Join",
    groups_members: "Members",
    
    // Settings
    settings_title: "Settings",
    settings_general: "General Settings",
    settings_lang: "Language",
    settings_notifications: "Notifications",
    settings_dnd: "Do Not Disturb",
    settings_daily_limit: "Daily Limit",
    settings_types: "Notification Types",
    settings_app_logo: "App Customization",
    settings_upload_logo: "Upload Custom Logo",
    settings_admin_only: "ADMIN ONLY",
    settings_sign_out: "Sign Out",

    // Common
    welcome: "Welcome back",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    xp_points: 'XP Points',
    btn_generate: 'Generate',
    pro_badge: 'PRO',
    unlimited_badge: 'ULTIMATE',
    login_sub: 'Enter your email to access your account or create a new one.',
    login_name: 'Full Name',
    login_ref: 'Referral Code (Optional)',
    login_pass: 'Password',
    login_signup_btn: 'Create Free Account',
    ref_title: 'Invite Friends, Get Free Gear',
    ref_sub: 'Share your code and earn a 10% discount for every friend who subscribes to PRO. 10 friends = 1 PRODUCT FOR FREE!',
    ref_code_lbl: 'Your Referral Code',
    ref_copy: 'Copy Link',
    ref_share: 'Share on Socials',
    ref_stats_title: 'Your Progress',
    ref_stat_invites: 'Total Invites',
    ref_stat_subs: 'Premium Friends',
    ref_stat_discount: 'Current Discount',
    ref_milestone: 'Refer {count} more for 100% discount!',
    ref_history: 'Referral History',
    ref_eligible: 'Referral Eligible',
    ref_not_eligible: 'Fixed Price Item',
    ref_apply_discount: 'Apply Referral Discount',
    ref_max_discount: 'Congrats! 100% OFF!',
    onboarding_title_1: 'PHYSICAL DATA',
    onboarding_sub_1: 'Personalize your VitaCore experience',
    onboarding_age: 'Age',
    onboarding_weight: 'Weight (kg)',
    onboarding_height: 'Height (cm)',
    onboarding_gender: 'Gender',
    onboarding_gender_male: 'Male',
    onboarding_gender_female: 'Female',
    onboarding_title_2: 'HEALTH & ALLERGIES',
    onboarding_sub_2: 'The AI Coach will use this for meals',
    onboarding_allergies_placeholder: 'Example: Lactose intolerance, nut allergy...',
    onboarding_title_3: 'TERMS & CONDITIONS',
    onboarding_sub_3: 'Important legal information',
    onboarding_terms_accept: 'I accept the Terms and Conditions',
    onboarding_title_4: 'YOUR JOURNEY STARTS NOW',
    onboarding_sub_4: 'Profile created successfully. Ready to unlock your potential?',
    onboarding_btn_next: 'NEXT',
    onboarding_btn_finalize: 'CHOOSE YOUR PLAN',
    upgrade_now: "Upgrade Now",
    locked_feature: "Unlock Premium Features",
    locked_subtitle: "This feature is available on Pro and Unlimited plans",
    free_limit: "Free Tier Limit Reached",
  },
  
  it: {
    // ... existing translations ...
    login_title: "Accedi",
    login_subtitle: "Unisciti all'ecosistema fitness definitivo",
    login_email: "Indirizzo Email",
    login_password: "Password",
    login_btn: "Continua con Email",
    login_google: "Continua con Google",
    login_facebook: "Continua con Facebook",
    signup_title: "Crea Account",
    need_account: "Hai bisogno di un account? Registrati",
    have_account: "Hai già un account? Accedi",
    
    // Onboarding
    onboarding_welcome: "Benvenuto in VitaCore",
    step_terms: "Termini e Condizioni",
    step_personal: "Informazioni Personali",
    step_body: "Metriche Corporee",
    step_health: "Salute e Dieta",
    step_plan: "Scegli il Tuo Piano",
    accept_terms: "Accetto i Termini e le Condizioni",
    label_name: "Nome",
    label_email: "Email",
    label_age: "Età",
    label_sex: "Sesso",
    label_height: "Altezza (cm)",
    label_weight: "Peso (kg)",
    btn_next: "Avanti",
    btn_start: "Inizia VitaCore",
    
    // Plans
    plan_free: "VitaCore GRATIS",
    plan_free_price: "0€/mese",
    plan_free_desc: "Accesso solo a Feed Social e Negozio",
    plan_pro: "VitaCore PRO",
    plan_pro_price: "9,99€/mese",
    plan_pro_desc: "Allenamenti IA personalizzati, Monitoraggio progressi, Cronologia",
    plan_unlimited: "VitaCore UNLIMITED",
    plan_unlimited_price: "14,99€/mese",
    plan_unlimited_desc: "Tutto PRO + Piani dietetici IA, Mappe Attive, Statistiche avanzate",
    
    // Navigation
    nav_feed: "Feed Social",
    nav_coach: "Coach IA",
    nav_map: "Mappe Attive",
    nav_shop: "Negozio",
    nav_dashboard: "Dashboard",
    nav_dash: "Dashboard",
    nav_groups: "Gruppi",
    nav_settings: "Impostazioni",
    nav_referral: 'Guadagna Premi',

    // Social Feed
    social_for_you: "Per te",
    social_following: "Seguiti",
    social_new_post: "Nuovo Post",
    social_post_placeholder: "Cosa stai pensando?",
    social_post_btn: "Pubblica",
    social_search_people: "Cerca persone",
    social_follow: "Segui",
    social_following_btn: "Seguito",
    social_likes: "mi piace",
    social_comments: "commenti",
    social_reply_placeholder: "Rispondi...",
    social_reply_btn: "Rispondi",
    
    // Coach
    coach_title: "Coach IA",
    coach_intro: "Sono il tuo Coach IA VitaCore. Chiedimi allenamenti, diete o analizza il tuo cibo.",
    coach_placeholder: "Descrivi il tuo obiettivo di allenamento o pasto...",
    coach_send: "Invia",
    coach_thinking: "Pensando...",
    
    // Maps
    map_title: "Trova Palestre e Percorsi",
    map_gyms: "Palestre",
    map_running: "Percorsi Corsa",
    map_cycling: "Ciclismo",
    map_trekking: "Trekking",
    map_view_on_maps: "Visualizza su Maps",
    map_select_category: "Seleziona una categoria per trovare percorsi o palestre",
    
    // Shop
    shop_title: "Negozio VitaCore",
    shop_all: "Tutti",
    shop_clothing: "Abbigliamento",
    shop_equipment: "Attrezzatura",
    shop_supplements: "Integratori",
    shop_add_to_cart: "Aggiungi al Carrello",
    
    // Dashboard
    dash_title: "Dashboard",
    dash_my_plans: "I Miei Piani IA",
    dash_edit_profile: "Aggiorna Metriche",
    dash_creator_mode: "Modalità Creator",
    dash_user_mode: "Modalità Utente",
    dash_challenges: "Sfide Attive",
    dash_create_challenge: "Crea Sfida",
    dash_join_challenge: "Unisciti",
    dash_joined: "Iscritto",
    dash_log_activity: "Registra Attività",
    dash_progress: "Progresso",
    dash_participants: "Partecipanti",
    dash_challenge_completed: "Sfida Completata!",
    dash_claim_reward: "Riscatta Premio",
    
    // Groups
    groups_title: "Hub Locali Creator",
    groups_subtitle: "Unisciti a club locali di corsa o community di creator",
    groups_join: "Unisciti",
    groups_members: "Membri",
    
    // Settings
    settings_title: "Impostazioni",
    settings_general: "Impostazioni Generali",
    settings_lang: "Lingua",
    settings_notifications: "Notifiche",
    settings_dnd: "Non Disturbare",
    settings_daily_limit: "Limite Giornaliero",
    settings_types: "Tipologie di Notifica",
    settings_app_logo: "Personalizzazione App",
    settings_upload_logo: "Carica Logo Personalizzato",
    settings_admin_only: "SOLO ADMIN",
    settings_sign_out: "Esci",

    // Common
    welcome: "Bentornato",
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    edit: "Modifica",
    xp_points: 'Punti XP',
    btn_generate: 'Genera',
    login_sub: 'Inserisci la tua email per accedere o creare un account.',
    login_name: 'Nome Completo',
    login_ref: 'Codice Referral (Opzionale)',
    login_pass: 'Password',
    login_signup_btn: 'Crea Account Gratuito',
    ref_title: 'Invita Amici, Ottieni Regali',
    ref_sub: 'Condividi il tuo codice e ottieni il 10% di sconto per ogni amico che si abbona a PRO. 10 amici = 1 PRODOTTO GRATIS!',
    ref_code_lbl: 'Il Tuo Codice Referral',
    ref_copy: 'Copia Link',
    ref_share: 'Condividi sui Social',
    ref_stats_title: 'I Tuoi Progressi',
    ref_stat_invites: 'Inviti Totali',
    ref_stat_subs: 'Amici Premium',
    ref_stat_discount: 'Sconto Attuale',
    ref_milestone: 'Invita altri {count} per lo sconto del 100%!',
    ref_history: 'Cronologia Inviti',
    ref_eligible: 'Scontabile con Referral',
    ref_not_eligible: 'Prezzo Fisso',
    ref_apply_discount: 'Applica Sconto Referral',
    ref_max_discount: 'Congratulazioni! 100% di SCONTO!',
    onboarding_title_1: 'DATI FISICI',
    onboarding_sub_1: 'Personalizza l\'esperienza VitaCore',
    onboarding_age: 'Età',
    onboarding_weight: 'Peso (kg)',
    onboarding_height: 'Altezza (cm)',
    onboarding_gender: 'Sesso',
    onboarding_gender_male: 'Maschio',
    onboarding_gender_female: 'Femmina',
    onboarding_title_2: 'SALUTE & ALLERGIE',
    onboarding_sub_2: 'L\'AI Coach userà questi dati per i pasti',
    onboarding_allergies_placeholder: 'Esempio: Intolleranza al lattosio, allergia alle noci...',
    onboarding_title_3: 'TERMINI E CONDIZIONI',
    onboarding_sub_3: 'Informazioni legali importanti',
    onboarding_terms_accept: 'Accetto i Termini e le Condizioni',
    onboarding_title_4: 'IL TUO VIAGGIO INIZIA ORA',
    onboarding_sub_4: 'Profilo creato con successo. Sei pronto a sbloccare il tuo vero potenziale genetico?',
    onboarding_btn_next: 'AVANTI',
    onboarding_btn_finalize: 'SCEGLI IL TUO PIANO',
    upgrade_now: "Effettua Upgrade",
    locked_feature: "Sblocca Funzioni Premium",
    locked_subtitle: "Questa funzione è disponibile nei piani Pro e Unlimited",
    free_limit: "Limite Piano Gratuito Raggiunto",
  },
  // ... other languages ...
  es: {
    // Login/Auth
    login_title: "Iniciar Sesión",
    login_subtitle: "Únete al ecosistema fitness definitivo",
    login_email: "Correo Electrónico",
    login_password: "Contraseña",
    login_btn: "Continuar con Email",
    login_google: "Iniciar sesión con Google",
    login_facebook: "Iniciar sesión con Facebook",
    signup_title: "Crear Cuenta",
    need_account: "¿Necesitas una cuenta? Regístrate",
    have_account: "¿Ya tienes cuenta? Inicia sesión",
    
    // Onboarding
    onboarding_welcome: "Bienvenido a VitaCore",
    step_terms: "Términos y Condiciones",
    step_personal: "Información Personal",
    step_body: "Métricas Corporales",
    step_health: "Salud y Dieta",
    step_plan: "Elige tu Plan",
    accept_terms: "Acepto los Términos y Condiciones",
    label_name: "Nombre",
    label_email: "Email",
    label_age: "Edad",
    label_sex: "Sexo",
    label_height: "Altura (cm)",
    label_weight: "Peso (kg)",
    btn_next: "Siguiente",
    btn_start: "Iniciar VitaCore",
    
    // Plans
    plan_free: "VitaCore GRATIS",
    plan_free_price: "$0/mes",
    plan_free_desc: "Acceso solo a Feed Social y Tienda",
    plan_pro: "VitaCore PRO",
    plan_pro_price: "$9.99/mes",
    plan_pro_desc: "Entrenamientos IA personalizados, Seguimiento de progreso, Historial",
    plan_unlimited: "VitaCore UNLIMITED",
    plan_unlimited_price: "$14.99/mes",
    plan_unlimited_desc: "Todo PRO + Planes dietéticos IA, Mapas Activos, Estadísticas avanzadas",
    
    // Navigation
    nav_feed: "Feed Social",
    nav_coach: "Coach IA",
    nav_map: "Mapas Activos",
    nav_shop: "Tienda",
    nav_dashboard: "Panel",
    nav_dash: "Dashboard",
    nav_groups: "Grupos",
    nav_settings: "Ajustes",
    nav_referral: 'Recompensas',

    // Social Feed
    social_for_you: "Para ti",
    social_following: "Siguiendo",
    social_new_post: "Nueva Publicación",
    social_post_placeholder: "¿Qué estás pensando?",
    social_post_btn: "Publicar",
    social_search_people: "Buscar personas",
    social_follow: "Seguir",
    social_following_btn: "Siguiendo",
    social_likes: "me gusta",
    social_comments: "comentarios",
    social_reply_placeholder: "Responder...",
    social_reply_btn: "Responder",
    
    // Coach
    coach_title: "Coach IA",
    coach_intro: "Soy tu Coach IA VitaCore. Pregúntame sobre entrenamientos, dietas o analiza tu comida.",
    coach_placeholder: "Describe tu objetivo de entrenamiento o comida...",
    coach_send: "Enviar",
    coach_thinking: "Pensando...",
    
    // Maps
    map_title: "Encontrar Gimnasios y Rutas",
    map_gyms: "Gimnasios",
    map_running: "Rutas para Correr",
    map_cycling: "Ciclismo",
    map_trekking: "Senderismo",
    map_view_on_maps: "Ver en Mapas",
    map_select_category: "Selecciona una categoría para encontrar rutas o gimnasios",
    
    // Shop
    shop_title: "Tienda VitaCore",
    shop_all: "Todos",
    shop_clothing: "Ropa",
    shop_equipment: "Equipo",
    shop_supplements: "Suplementos",
    shop_add_to_cart: "Añadir al Carrito",
    
    // Dashboard
    dash_title: "Panel",
    dash_my_plans: "Mis Planes IA",
    dash_edit_profile: "Actualizar Métricas",
    dash_creator_mode: "Modo Creador",
    dash_user_mode: "Modo Usuario",
    dash_challenges: "Desafíos Activos",
    dash_create_challenge: "Crear Desafío",
    dash_join_challenge: "Unirse",
    dash_joined: "Unido",
    dash_log_activity: "Registrar Actividad",
    dash_progress: "Progreso",
    dash_participants: "Participantes",
    dash_challenge_completed: "¡Desafío Completado!",
    dash_claim_reward: "Reclamar Recompensa",
    
    // Groups
    groups_title: "Hubs Locales de Creadores",
    groups_subtitle: "Únete a clubes locales de running o comunidades de creadores",
    groups_join: "Unirse",
    groups_members: "Miembros",

    // Settings
    settings_title: "Ajustes",
    settings_general: "Ajustes Generales",
    settings_lang: "Idioma",
    settings_notifications: "Notificaciones",
    settings_app_logo: "Personalización de App",
    settings_upload_logo: "Subir Logo Personalizado",
    settings_admin_only: "SOLO ADMIN",
    settings_sign_out: "Cerrar Sesión",

    // Common
    welcome: "Bienvenido de nuevo",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    upgrade_now: "Mejorar Ahora",
    locked_feature: "Desbloquear Funciones Premium",
    locked_subtitle: "Esta funzione è disponibile nei piani Pro e Unlimited",
    free_limit: "Límite de Plan Gratuito Alcanzado",
  },
  // ... other languages simplified for brevity in this snippet ...
};
